import {Observable, of} from 'rxjs';
import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';
import {select, Store} from '@ngrx/store';
import * as fromRoot from '../reducers';
import {LoadApiKeys} from '../actions/accounts.actions';
import {catchError, filter, switchMapTo, take, tap} from 'rxjs/operators';

@Injectable()
export class ApiKeysGuard implements CanActivate {

  constructor(private store: Store<fromRoot.State>) {
  }

  public canActivate(): Observable<boolean> {
    return this.checkApiKeys()
      .pipe(
        switchMapTo(of(true)),
        catchError(() => of(false))
      );
  }

  checkApiKeys(): Observable<boolean> {
    return this.store.pipe(
      select(fromRoot.selectApiKeysLoaded),
      tap(isLoaded => {
        if (!isLoaded) {
          this.store.dispatch(LoadApiKeys());
        }
      }),
      filter(isLoaded => isLoaded),
      take(1)
    );
  }
}
